import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import { nanoid } from "nanoid";
import SocketServices from "../../../utils/socket.services";
import Loader from 'react-loader-spinner'
import { checkTranslation, createMessengerInfo, imageAddress, translate } from "../../../utils/useful";
import moment from 'jalali-moment'
import HttpServices from "../../../utils/Http.services";
import FormViewer from "../../FormViewer";
import MessageBox from "../../../components/boxes/MessageBox";
import { getBoundingClientRect } from "../../../utils/functions";
import MessengerAttachments from "./MessengerAttachments";
import Dropzone from "react-dropzone";
import MessengerDropModal from "./MessengerDropModal";
import MessengerRecording from "./MessengerRecording";
import StickersView from "./StickersView";
import MessageNoMoreMessage from "../../boxes/MessageNoMoreMessage";
import Modal from "../../Modal";
import store from "../../../stores/storeConfig";
import MessengerTopics from "./MessengerTopics";
import FixedView from "../../FixedView";
import ButtonAnimated from "../../buttons/ButtonAnimated";
import ActionsBtn from "../../partials/ActionsBtn";
import importedIcons from "../../inputs/icons";
import MessengerSelectMyRef from "./MessengerSelectMyRef";
import SidebarView from "../../SidebarView";
import Topics from "./sideBar/Topics";

class MessengerView extends Component {

    state = {
        text: '',
        messengerId: nanoid(),
        topicId: nanoid(),
        headers: [
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}messenger.Name', placeholder: '{{lang}}messenger.Name', required: true } },
            { key: 'phone', type: 'TextInput', col: '12', information: { label: '{{lang}}messenger.Phone', placeholder: '{{lang}}messenger.Phone', required: true }, showMain: false },
        ],
        inputHeight: 36,
        visibleList: {},
        attachmentsList: [
            { name: '{{lang}}messenger.Album', icon: '/assets/icons/useful/album.svg', function: null },
            { name: '{{lang}}messenger.File', icon: '/assets/icons/useful/save.svg', function: null },
            { name: '{{lang}}messenger.Camera', icon: '/assets/icons/useful/camera.svg', function: null },
            { name: '{{lang}}messenger.Command', icon: '/assets/icons/useful/command.svg', function: null },
            { name: '{{lang}}messenger.Location', icon: '/assets/icons/useful/location.svg', function: null },
            { name: '{{lang}}messenger.Contact', icon: '/assets/icons/useful/save.svg', function: null },
            { name: '{{lang}}messenger.Form', icon: '/assets/icons/useful/save.svg', function: null },
            { name: '{{lang}}messenger.Drive', icon: '/assets/icons/useful/save.svg', function: null },
            { name: '{{lang}}messenger.Task', icon: '/assets/icons/useful/save.svg', function: null },
            { name: '{{lang}}messenger.Reminder', icon: '/assets/icons/useful/reminder.svg', function: null },
            { name: '{{lang}}messenger.Calendar', icon: '/assets/icons/useful/save.svg', function: null },
            { name: '{{lang}}messenger.Room', icon: '/assets/icons/useful/save.svg', function: null },
            { name: '{{lang}}messenger.Format', icon: '/assets/icons/useful/save.svg', function: null },
            { name: '{{lang}}messenger.Products', icon: '/assets/icons/useful/save.svg', function: null },
            { name: '{{lang}}messenger.Applets', icon: '/assets/icons/useful/save.svg', function: null },
        ],
        messengerInformation: false,
        header: [
            { key: 'hubs', type: 'GlobalUserMultiInput', information: { label: '{{lang}}messenger.Add Hubs', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}messenger.Select', required: false, } },
            // { key: 'assignee', type: 'MultiSelectInput', information: { label: '{{lang}}Assignee', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}select', required: false, } },
        ],
        parents: [],
        messengerName: '',
        selectList: [],
        showSelect: false,
        messengerUsers: [],
        selectOption: [
            // { icon: "/assets/icons/messenger/reply.svg", title: "Reply", key: 'reply', color: "#444" },
            // { icon: "/assets/icons/messenger/copy.svg", title: "Copy", key: 'copy', color: "#444" },
            // { icon: "/assets/icons/messenger/edit.svg", title: "Edit", key: 'edit', color: "#444" },
            // { icon: "/assets/icons/messenger/pin.svg", title: "Pin", key: 'pin', color: "#444" },
            { icon: "/assets/icons/messenger/forward.svg", title: "{{lang}}messenger.Forward", key: 'forward', color: "#444" },
            // { icon: "/assets/icons/messenger/select.svg", title: "Select", key: 'select', color: "#444" },
            { icon: "/assets/icons/messenger/trash.svg", title: "{{lang}}messenger.Delete", key: 'delete', color: "#FF3B30" },
        ],
        onEdit: {},
        row: 1,
        actions: {
            // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            templateMessage: { key: "templateMessage", label: '{{lang}}Template Message', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "useTemplateMessage", icon: importedIcons.addCustomField },
        },
    }

    componentDidMount() {
        this.init()
        // this.checkParent()
        this.setMessengerInfo()
        window.addEventListener('resize', this.updateWidth)
        let options = {
            root: document.querySelector('#messenger-' + this.state.messengerId),
            rootMargin: '0px 0px -50px 0px',
            // rootMargin: '0px 0px 0px 0px',
            threshold: 0.8
        }
        // if (this.props.isApplet && this.props.applet.settings && this.props.applet.settings.type && this.props.applet.settings.type == 'support') {
        //     this.firstView.showView()
        // }
        this.observer = new IntersectionObserver(this.observerAction, options);
        // setTimeout(() => {
        // }, 10000);
        // let messages = document.querySelectorAll('messageBox')
        // this.observer.observe()
        // document.addEventListener("keydown", this.handleKeyDown);
        // document.addEventListener("keydown", this.handleKeyDownChange);
    }

    actionClicked = (prop, data, extra) => {
        if (this[prop.function]) {
            this[prop.function](data, extra)
        }

    }

    observerAction = (entries) => {
        let msgId = entries[0].target.id.split('msg-').at(-1)
        let data = {}
        this.props.messengers?.messages[this.props.messenger?._id]?.map((prop) => {
            if (prop._id == msgId) {
                data = prop
            }
        })
        if (entries && entries[0]) {
            let top = false
            if (entries[0].intersectionRect && entries[0].intersectionRect.top < 10) {
                top = true
            }
            this.onViewableItemsChanged(data, entries[0].isIntersecting, top)
        }
    }

    useTemplateMessage = (data, extra) => {
        // console.log('*useTemplateMessagedata', data, extra)
        let rawData = { text: data.description }
        this.createMessage(rawData, (message) => {
            this.sendMessageToServer(message)
        })
    }

    componentWillUnmount = () => {
        this.unSubscribeTopic()
        // document.removeEventListener("keydown", this.handleKeyDown);
        // document.removeEventListener("keydown", this.handleKeyDownChange);
    }

    convertDate = (status, cb) => {
        if (status?.la) {
            // let date = moment.unix(status.la).format('MM/DD/YYYY')
            let date = moment(Number(status.la)).format("MM/DD/YYYY")
            let nStatus = { ...(status ?? {}) }
            nStatus.la = date
            cb(nStatus)
        }
    }

    getOnlineStatus = (hub, cb, time = 1, tryTime = 0) => {
        setTimeout(() => {
            if (SocketServices.socket?.connected) {
                if (hub) {
                    SocketServices.emit('getHubStatus', { hub: hub }, null, (info, err) => {
                        this.convertDate(info, (status) => {
                            this.setState({ hubStatus: status }, () => {
                                cb()
                            })
                        })
                    })
                }
                else {
                    cb()
                }
            }
            else {
                if (tryTime < 10) {
                    this.getOnlineStatus(hub, cb, time + 5, tryTime + 1)
                }
            }
        }, time * 1000);
    }

    unSubscribeTopic = () => {
        let hub
        if (this.props.messenger) {
            for (let i = 0; i < this.props.messenger.interactiveUsers?.length; i++) {
                if (this.props.messenger.interactiveUsers[i].hub != (this.props.user?.info?._id ?? this.props.tempUser)) {
                    hub = this.props.messenger.interactiveUsers[i].hub
                }
            }
        }
        else if (this.props.potentialUser) {
            hub = this.props.potentialUser?.creator
        }
        if (hub) {
            SocketServices.removeTopic(this.state.topicId, (this.props.user?.info?._id ?? this.props.tempUser), 'user:' + (hub._id ?? hub), null)
        }
    }

    checkParent = () => {
        // console.log('*checkParent')
        if (this.props.messenger && this.props.messenger?.type != 'support') {
            let parents = []
            if (this.props.messenger.parent) {
                let generalMessenger = {}
                for (let i = 0; i < this.props.messengers.list.length; i++) {
                    if (this.props.messengers.list[i]?._id == this.props.messenger.parent) {
                        generalMessenger = { ...this.props.messengers.list[i] }
                        generalMessenger.name = 'general'
                        generalMessenger['**name'] = 'general'
                    }
                    else if (this.props.messengers.list[i]?.parent == this.props.messenger.parent) {
                        let messenger = this.props.messengers.list[i]
                        messenger['**name'] = this.props.messengers.list[i].name
                        parents.push(messenger)
                    }
                }
                if (parents.length != 0) {
                    generalMessenger.name = 'general'
                    generalMessenger['**name'] = 'general'
                    parents.splice(0, 0, generalMessenger)
                }
            }
            else {
                for (let i = 0; i < this.props.messengers.list.length; i++) {
                    if (this.props.messengers.list[i]?.parent == this.props.messenger._id) {

                        let messenger = this.props.messengers.list[i]
                        messenger['**name'] = this.props.messengers.list[i].name
                        parents.push(messenger)

                    }
                }
                if (parents.length != 0) {
                    let generalMessenger = { ...this.props.messenger }
                    generalMessenger.name = 'general'
                    generalMessenger['**name'] = 'general'
                    parents.splice(0, 0, generalMessenger)
                }
            }
            parents = parents.sort((a, b) => new Date(b.cDate).getTime() + new Date(a.cDate).getTime())
            this.setState({ parents }, () => {

                this.props?.setTopics(parents)
                this.setState({ isLoading: false })
            })
            // for (let i = 0; i < array.length; i++) {
            //     const element = array[i];
            // }
            // HttpServices.request('getParents', { _id: this.props.messenger._id }, (fetchResult, fetchError) => {
            //     if (fetchError) {
            //         return
            //     }
            //     let parents = this.state.parents
            //     if (!parents[this.props.messenger]) {
            //         parents[this.props.messenger._id] = []
            //     }
            //     parents[this.props.messenger._id] = fetchResult.info
            //     this.setState({ parents }, () => {
            //         this.setState({ isLoading: false })
            //     })
            // })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.messenger?._id !== prevProps.messenger?._id) {
            this.setState({ hubStatus: null })
            this.init()
            // this.checkParent()
            this.subscribeTopic()
            this.setMessengerInfo()
        }
        if (this.props.potentialUser != prevProps.potentialUser) {
            // this.checkParent()
            this.setState({ hubStatus: null })
            // console.log('on potentialuser change')
            this.init()
            this.subscribeTopic()
            this.setMessengerInfo()
        }
        if (prevProps?.messenger) {
            if (!this.props.messengers?.object[prevProps.messenger?._id]?.['lastMsg']?._id || this.props.messengers?.object[prevProps.messenger?._id]?.['lastMsg']?._id != this.lastMsg && this.props.messengers?.object[prevProps.messenger?._id]) {
                // if (this.props.messengers?.object[prevProps.messenger?._id]) {
                this.lastMsg = this.props.messengers?.object[prevProps.messenger?._id]?.['lastMsg']?._id
                // }
                if (this.messagesContainer && (this.messagesContainer.scrollHeight - this.messagesContainer.scrollTop - this.messagesContainer.offsetHeight < 250)) {
                    //   console.log("TP1")
                    this.scrollToBottom(true)  // SHOULD ADD
                }
            }
        }
    }

    subscribeTopic = () => {
        let hub
        if (this.props.messenger) {
            for (let i = 0; i < this.props.messenger.interactiveUsers?.length; i++) {
                if (this.props.messenger.interactiveUsers[i].hub != (this.props.user?.info?._id ?? this.props.tempUser)) {
                    hub = this.props.messenger.interactiveUsers[i].hub
                }
            }
        }
        else if (this.props.potentialUser) {
            hub = this.props.potentialUser?.creator
        }
        if (hub) {
            SocketServices.addTopic(this.state.topicId, (hub._id ?? hub), 'user', null, this.updateStatus)
            this.getOnlineStatus(hub, () => {
            })
        }
    }

    openUserInfo = (item) => {
        this.setState({ userInfo: item }, () => {
            this.userInfoModal.showModal()
        })
    }

    // removeUser = (item) => {
    //     HttpServices.request('removeUser', item, (fetchResult, fetchError) => {
    //         if (fetchError) {
    //             return
    //         }
    //         let userInfo = this.state.userInfo
    //         let currentMessenger = this.state.currentMessenger
    //         userInfo = {}
    //         currentMessenger = {}
    //         this.setState({ userInfo, currentMessenger })
    //     })
    // }

    checkIfMessengerExists = (time, tryTime = 0) => {

        // console.log('checkIfMessengerExists')

        if (!this.props.messenger && this.props.potentialUser) {
            if (time == null) {
                time = 0
            }

            if (this.props.frame?.mode == 'support') {
                return
            }

            setTimeout(() => {
                if (SocketServices.socket?.connected) {

                    let targetFrame = this.props.potentialFrame?._id ?? this.props.potentialFrame
                    let myFrame = this.props.myPotentialFrame?._id ?? this.props.myPotentialFrame

                    // let potentialApplet = typeof this.props.potentialUser == 'object' ? this.props.potentialUser._id : this.props.potentialUser
                    // let userFrame = this.props.page?._id
                    // console.log('checkPotential', JSON.parse(JSON.stringify({ userFrame, potentialApplet })))
                    SocketServices.emit('checkIfMessengerExists', { myFrame, targetFrame }, null, (info, err) => {

                        // console.log('checkIfMessengerExists', info)

                        if (info?.messenger) {
                            actions.addMessengers(info.messenger)
                            setTimeout(() => {
                                // console.log("HERE")
                                this.props.setMessenger(info.messenger, () => {
                                })
                            }, 50);
                        }

                    })
                } else {
                    if (tryTime < 10) {
                        this.checkIfMessengerExists(time + 5, tryTime + 1)
                    }
                }
            }, time * 50);
        }
        // else if (this.props.potentialUser) {

        //     if(tryTime < 10){
        //         this.checkIfMessengerExists(time + 5, tryTime + 1)

        //     }
        // }, time * 50);
        // }
    }

    scrollChanged = (e) => {
        if (this.messagesContainer && (this.messagesContainer.scrollTop < 200 && this.messagesContainer.scrollTop >= -1 && !this.state.isOnLast && !this.state.isLoadingInfo)) {
            if (this.messagesContainer.scrollTop < 1) {
                this.messagesContainer.scrollTo({ top: 1, behavior: 'auto' })
            }
            this.fetchData()
        }
    }

    setMessengerInfo = () => {

        let messenger = this.props.messenger
        let potentialUser = this.props.potentialUser

        // console.log("setMessengerInfo",potentialUser)

        let myId = this.state.myId
        // if (this.props.isApplet == true) {
        //     myId = this.props.variables?.appletHub?._id ?? this.props.variables?.appletHub
        // } else {
        //     myId = (this.props.user?.info?._id ?? this.props.tempUser)
        // }
        // if (!myId) {
        myId = this.props.user?.info?._id ?? this.props.tempUser
        // }

        // console.log("this.props.user", this.props.user)
        // console.log("messenger", messenger)

        this.setState({ myId }, () => {
            let messengerInfo = {}
            let chatUsers = {}
            let chatInteractive = {}

            let myValidRefs
            let myActiveRef

            if (!messenger) {
                if (potentialUser) {

                    if (this.props.frame?.settings?.type == 'support') {

                        messengerInfo = {
                            name: this.props.frame?.name,
                            type: potentialUser.settings?.type,
                            image: potentialUser.image,
                        }

                    } else {
                        messengerInfo = {
                            name: potentialUser?.fullname ? potentialUser?.fullname : potentialUser?.hub?.fullname,
                            type: potentialUser?.type ? potentialUser?.type : potentialUser?.hub?.type,
                            role: potentialUser?.role ? potentialUser?.role : potentialUser?.hub?.role,
                            image: potentialUser?.image ? potentialUser?.image : potentialUser?.hub?.image,
                        }
                    }
                }
            } else {


                let interactiveUsers = messenger.interactiveUsers
                let users = messenger.users
                myValidRefs = messenger['**myValidRefs']

                // let user

                for (let i = 0; i < interactiveUsers.length; i++) {
                    const element = interactiveUsers[i]
                    chatInteractive[element?.hub?._id] = element
                }

                users?.forEach(element => {

                    chatUsers[element?.hub?._id] = element

                })


                // // console.log('messenger', messenger)

                // if (messenger.type == 'group') {

                //     // messengerInfo = {
                //     //     name: messenger.name,
                //     //     type: messenger.type,
                //     //     role: messenger.role,
                //     //     image: messenger.image,
                //     // }

                // } else {


                //     if (this.props.frame?.settings?.type == 'support') {

                //         let isAdmin
                //         if (Array.isArray(messenger.interactiveUsers)) {
                //             messenger.interactiveUsers.forEach(element => {
                //                 // console.log('element---', element)
                //                 // console.log('myId---', this.state.myId)
                //                 if (element.hub?._id == this.state.myId && element.admin) {
                //                     isAdmin = true
                //                 }
                //             })
                //         }
                //         if (isAdmin) {
                //             messenger.users?.forEach(element => {
                //                 if (element.hub?._id != this.state.myId) {
                //                     messengerInfo = {
                //                         name: element.hub.fullname,
                //                         // type: potentialUser.name,
                //                         // role: messenger.name,
                //                         image: element.hub.image,
                //                     }
                //                 }
                //             })
                //         } else {
                //             // name = messenger.name
                //             messengerInfo = {
                //                 name: messenger.name,
                //                 // type: potentialUser.name,
                //                 // role: messenger.name,
                //                 image: messenger.image,
                //             }
                //         }

                //     } else {

                //         messengerInfo = {
                //             name: user?.hub?.fullname,
                //             type: user?.hub?.type,
                //             role: user?.hub?.role,
                //             image: user?.hub?.image,
                //         }
                //     }
                // }


                messengerInfo = {
                    name: messenger['**name'],
                    image: messenger['**image'],
                }


                if (this.props.frame?._id && messenger["**info"]) {


                    if (messenger["**info"][this.props.frame?._id]) {
                        messengerInfo.name = messenger["**info"][this.props.frame?._id]?.name
                        messengerInfo.image = messenger["**info"][this.props.frame?._id]?.image
                    }

                    if (!this.props.adminView && messenger["**userInfo"] && messenger["**userInfo"][this.props.frame?._id]) {
                        messengerInfo.name = messenger["**userInfo"][this.props.frame?._id]?.name
                        messengerInfo.image = messenger["**userInfo"][this.props.frame?._id]?.image
                    }

                }

                if (messenger.parent) {
                    messengerInfo.topicName = messenger.name
                }

            }

            // if(!this.props.adminView){
            //     console.log(this.props.frame?._id,messenger)
            // console.log("messengerInfo", myId, messengerInfo)

            // }




            this.setState({ myId, messengerInfo, chatUsers, chatInteractive, myValidRefs }, () => {
                this.checkIfMessengerExists()

                if (Array.isArray(myValidRefs) && myValidRefs.length == 1) {

                    this.setMyActiveRef(myValidRefs[0])

                }

            })
        })
    }

    init() {
        // if (!this.props.isApplet && !this.props.messenger) {
        //     this.props.setMessenger()
        // }
        if (this.props.isApplet) {
            this.props.selectApplet(this.props.variables?.applet?._id)
        }
        this.setData()
        this.visibleList = {}
        if (this.props.messenger) {
            // if (!this.props.messengers?.object || !this.props.messengers?.object[this.props.messenger?._id]) {
            //     this.props.actions.addMessengers([JSON.parse(JSON.stringify(this.props.messenger))])
            // }
            this.messagesContainer.removeEventListener('scroll', this.scrollChanged)
            this.messagesContainer.addEventListener('scroll', this.scrollChanged)
            this.setState({ showNewMessagesBox: null, data: [], currentPage: 0, totalCount: null, filter: null, isOnLast: false, hideAssigne: false }, () => {
                let scrollToBottom = true
                let newMessagesCount = this.props.messengers.notifications[this.props.messenger?._id]
                if (newMessagesCount && newMessagesCount != 0) {
                    this.setState({ showNewMessagesBox: this.props.messenger.alastSeen })
                    scrollToBottom = false
                } else {
                    this.scrollToBottom()
                }
                this.fetchData(true)
            })
        }
    }

    updateStatus = (statusInfo) => {
        this.convertDate(statusInfo, (status) => {
            this.setState({ hubStatus: status })
        })
    }

    fetchData = (init) => {
        let item = this.props.messenger
        let time = new Date().getTime()
        if (item && !this.state.isLoadingInfo && !this.state.isOnLast) {
            let body = { messenger: item._id }
            if (this.props.messengers?.messages[this.props.messenger?._id]) {
                let lng = this.props.messengers?.messages[this.props.messenger?._id]?.length
                if (lng) {
                    body.lastMsg = this.props.messengers?.messages[this.props.messenger?._id][lng - 1]
                }
            }
            if (body.lastMsg?._id) {
                body.lastMsg = body.lastMsg._id
            }
            if (typeof body.lastMsg != 'object') {
                this.setState({ isLoadingInfo: true, oneDataList: [] })
                HttpServices.request('getMessengerMessages', body, (fetchResult, fetchError) => {
                    if (this.messagesContainer) {
                        let timer = 600 - (new Date().getTime() - time)
                        if (timer < 0 || init) {
                            timer = 0
                        }
                        if (this.messagesContainer && this.messagesContainer.scrollTop < 1 && !init) {
                            this.messagesContainer.scrollTo({ top: 1, behavior: 'auto' })
                        }
                        setTimeout(() => {
                            if (this.messagesContainer?.scrollTop < 1 && !init) {
                                this.messagesContainer.scrollTo({ top: 1, behavior: 'auto' })
                            }
                            this.setState({ isLoadingInfo: false }, () => {
                            })
                            if (fetchError) {
                                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                                return
                            }
                            let NewBottomHeight = this.messagesContainer?.scrollHeight - this.messagesContainer?.scrollTop //- this.messagesContainer.offsetHeight
                            this.props.actions.appendOneMessage(item._id, fetchResult.info)
                            // setTimeout(() => {
                            //     const boxElList = document.querySelectorAll(".messageBox");
                            //     boxElList.forEach((el) => {
                            //         this.observer.observe(el);
                            //     });
                            // }, 500);
                            let newHeight = this.messagesContainer.scrollHeight
                            this.messagesContainer.scrollTo({ top: newHeight - NewBottomHeight, behavior: 'auto' })
                            if (!fetchResult.info || fetchResult.info.length < 20) {
                                this.setState({ isOnLast: true }, () => {
                                    newHeight = this.messagesContainer.scrollHeight
                                    this.messagesContainer.scrollTo({ top: newHeight - NewBottomHeight, behavior: 'auto' })
                                })
                            }
                            if (init || this.messagesContainer.scrollHeight - this.messagesContainer.scrollTop - this.messagesContainer.offsetHeight < 250) {
                                this.scrollToBottom()
                                setTimeout(() => {
                                    this.scrollToBottom()
                                }, 5);
                            }
                        }, timer);
                    }
                })
            }
        }
    }

    updateInput = (element) => {
        let shadow = this.input
        let row = element.value.split("\n")
        row = row.length
        // console.log(element.value.trim()[0])
        let direction = element.value ? this.detectDirection(element.value.trim()[0]) : 'ltr'
        // console.log("direction",direction)

        this.setState({ text: element.value, row, textBoxDirextion: direction }, () => {
            shadow.focus()
            // this.sendNotifToServer(this.props.messenger._id)
            shadow.style.height = 'inherit';
            shadow.style.height = (shadow.scrollHeight) + "px";
            let height = getBoundingClientRect(shadow).height
            if (!element.style) {
                element.style = {}
            }
            element.style.height = height + 'px'
            this.setState({ inputHeight: height })
            if (this.state.text && this.props.messenger) {
                this.props.sendNotif('isTyping', true, this.props.messenger._id, () => {
                })
            }
            else if (!this.props.text && this.props.messenger) {
                this.props.sendNotif('isTyping', false, this.props.messenger._id, () => {
                })
            }
        })
    }

    deleteMessageAction = (key) => {
        if (key == 'all') {
            this.deleteMessage(this.data._id, this.messenger, this.myId, key, () => {
                this.deletemessage.hideModal()
            })
        }
        else {
            this.deleteMessage(this.data._id, this.messenger, this.myId, key, () => {
                this.deletemessage.hideModal()
            })
        }
    }

    sendFileMessage = (files, key, text) => {
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            let myKey = key
            if (key == 'album') {
                if (file.type.startsWith('image')) {
                    myKey = 'image'
                }
                if (file.type.startsWith('video')) {
                    myKey = 'video'
                }
            }
            let rawmessage = {
                key: myKey,
                tempFile: file,
                text: text && text
                // ['temp-' + myKey]: file,
            }
            this.createMessage(rawmessage, (message) => {
                this.props.actions.addMessages(this.props.messenger?._id, [message])
                HttpServices.addUploadQueque(file, { messenger: this.props.messenger?._id, type: 'message', key: myKey }, message.tempId)
                this.scrollToBottom(true)
            })
        }
    }

    sendTextMessage = () => {
        let rawmessage = {
            text: this.state.text,
            direction: this.state.textBoxDirextion
        }
        let input = this.input
        // console.log('sendTextMessage',text)
        if (this.state.text.trim() != '' && this.state.text.trim() != undefined && this.state.text.trim() != null) {
            this.setState({ text: '', row: 1 }, () => {
                input.style.height = '36px';
                input.focus()
                input.style.height = 'inherit';
                input.style.height = (input.scrollHeight) + "px";
                let height = getBoundingClientRect(input).height
                this.setState({ inputHeight: height })
                this.createMessage(rawmessage, (message) => {
                    this.sendMessageToServer(message)
                })
            })
        } else {
            this.setState({ text: '' })
        }
    }

    createMessage = (rawmessage, cb) => {
        if (this.props.messenger) {

            const timezoneOffset = (new Date()).getTimezoneOffset()
            let myFrame = this.state.myActiveRef?.frame
            let senderHub = this.state.myActiveRef?.hub
            let isAdmin = this.props.messenger?.type == 'support' ? (this.props.adminView ? true : false) : null

            // console.log(this.state.myActiveRef, senderHub)
            let message = {
                sender: this.state.myId,
                senderFrame: myFrame?._id ?? myFrame,
                senderHub: senderHub?._id ?? senderHub,
                isAdmin,
                // senderHub: this.props.variables.appletHub ? (this.props.variables.appletHub._id ?? this.props.variables.appletHub) : this.props.variables.appletHub,
                // senderHub: (this.props.variables && this.props.variables.appletHub) ? this.props.variables.appletHub._id : ((this.props.currentApplet && this.props.currentApplet.appletHub) ? this.props.currentApplet.appletHub._id : senderHub),
                // senderHub: this.props.variables?.appletHub?._id ?? this.props.variables?.appletHub,
                // applet: this.props.currentApplet ? (this.props.currentApplet._id ?? this.props.currentApplet) : this.props.variables?.applet?._id,
                // applet: this.props.currentApplet ? (this.props.currentApplet._id ?? this.props.variables?.applet?._id) : this.props.variables?.applet?._id,
                messenger: this.props.messenger?._id,
                tempId: nanoid(),
                status: 0,
                cDate: new Date().getTime(),
                tz: timezoneOffset,
                trashed: false
            }

            message = { ...message, ...rawmessage }

            // console.log('mymessage', message)
            // return
            cb(message)

        } else {
            this.requestcreateMessenger(0, 1, rawmessage, (info) => {
                this.createMessage(rawmessage, cb)
            })
        }
    }

    sendMessageToServer = (message) => {
        // console.log("sendMessageToServer", message)
        let tempSequence = this.props.messenger.sequence + 1
        this.props.actions.addMessages(this.props.messenger?._id, [message], null, tempSequence)
        SocketServices.sendMessage(this.props.messenger?._id, message)
        this.props.sendNotif('isTyping', false, this.props.messenger._id, () => {
        })
        this.scrollToBottom(true)
    }

    requestcreateMessenger = (time, tryTime, message, cb) => {

        // console.log("requestcreateMessenger")
        setTimeout(() => {
            if (SocketServices?.socket?.connected) {
                // console.log('userApplet: this.props.currentApplet._id, potentialApplet: this.props.potentialUser?._id', { userApplet: this.props.currentApplet._id, potentialApplet: this.props.potentialUser?._id })
                // return
                let targetFrame = this.props.potentialFrame?._id ?? this.props.potentialFrame
                let myFrame = this.props.myPotentialFrame?._id ?? this.props.myPotentialFrame

                // console.log('myFrame, targetFrame', myFrame, targetFrame)

                //todo

                SocketServices.emit('createMessenger', { myFrame, targetFrame }, null, (info, err) => {

                    // console.log("requestcreateMessenger", info)

                    if (info?.messenger) {
                        // let name = info.messenger?.name
                        // let name
                        // if (!name) {
                        //     // info.messenger.users.forEach(element => {
                        //     //     if (element.hub._id != this.state.myId) {
                        //     //         name = element.hub.fullname
                        //     //     }
                        //     // })
                        //     // console.log('info.messengerNew', info.messenger)
                        //     if (info.messenger.type == 'support') {
                        //         let isAdmin
                        //         info.messenger.interactiveUsers.forEach(element => {
                        //             // console.log('element---', element)
                        //             // console.log('myId---', this.state.myId)
                        //             if (element.hub?._id == this.state.myId && element.admin) {
                        //                 isAdmin = true
                        //             }
                        //         })
                        //         if (isAdmin) {
                        //             info.messenger.users?.forEach(element => {
                        //                 if (element.hub?._id != this.state.myId) {
                        //                     name = element.hub.fullname
                        //                 }
                        //             })
                        //         } else {
                        //             name = info.messenger.name
                        //         }
                        //     }
                        //     else {
                        //         info.messenger.interactiveUsers.forEach(element => {
                        //             if (element.hub._id != this.state.myId && Array.isArray(element.refs)) {
                        //                 name = element.refs[0]?.hub?.fullname
                        //             }
                        //         })
                        //     }

                        // }
                        // info.messenger["**name"] = name
                        // let messenger = info.messenger
                        // if (!Array.isArray(messenger)) {
                        //     messenger = [messenger]
                        // }

                        // console.log("TP1")

                        this.props.actions.addMessengers([info.messenger], false, this.state.myId)

                        // console.log("TP2")

                        setTimeout(() => {
                            // console.log("HERE1", info.messenger, this.state.myId)
                            this.props.setMessenger(createMessengerInfo(info.messenger, this.state.myId), () => {
                                cb()
                            })
                        }, 50);
                    } else {
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.failedToSendDate', description: "Failed" })
                    }
                });
            } else {
                if (tryTime < 10) {
                    this.requestcreateMessenger(time + 5, tryTime + 1, message)
                }
            }
        }, time * 50);
    }

    submitForm = () => {
        let data = this.form.getForm()
        if (data) {
            this.requestcreateMessenger(0, 1, data, (info) => {
                let form = {}
                for (const [key, value] of Object.entries(data)) {
                    let label = ''
                    this.state.headers.forEach(header => {
                        if (header.key == key) {
                            label = header.information.label
                        }
                    });
                    form[key] = { key, value, label }
                }
                let message = { form }
                this.createMessage(message)
            })
        }
    }

    onViewableItemsChanged = (msg, isIntersecting, top) => {
        // let toppestDate = this.state.toppestDate
        // console.log(msg)
        let id = msg?._id ?? msg?.tempId
        if (!isIntersecting) {
            delete this.visibleList[id]
        } else {
            this.visibleList[id] = msg
        }
        let toppestDate = this.state.toppestDate
        let newDate
        let newDataObj = {}
        Object.values(this.visibleList).forEach(element => {
            if (element && (new Date(element.cDate).getTime() < new Date(newDate).getTime() || !newDate)) {
                newDate = new Date(element.cDate).getTime()
                newDataObj = element
            }
        });
        if (newDate != toppestDate) {
            this.setState({ toppestDate: newDate })
        }
        // if (newDataObj) {
        //     // setTimeout(() => {
        //     let newObjectId = newDataObj?._id ?? newDataObj?.tempId
        //     let result = this.isInViewport(newObjectId)
        //     if (!result) {
        //         delete this.visibleList[newObjectId]
        //         setTimeout(() => {
        //         this.onViewableItemsChanged(newDataObj, false)
        //         }, 100);
        //     }
        //     // }, 1);
        // }
        // this.visibleList[]
        // if (!toppestDate || top) {
        //     this.setState({ toppestDate: msg.cDate })
        // }

        // console.log("onViewableItemsChanged", isIntersecting, msg.sender, this.state.myId,msg)

        if (isIntersecting && (msg.sender != this.state.myId)) {
            // viewableItems.forEach(viewableItem => {
            // if (msg.myId != this.state.myId && msg.status != 2) {
            let isAlreadySeen = msg.seen ? (msg.seen[this.state.myId]) : false

            // console.log(isAlreadySeen, msg.status,msg)
            // console.log("msg.seen", msg.seen,this.state.myId)


            if (!isAlreadySeen) {

                // if (((msg.status != 2) || ((msg?.type == 'action' || msg?.type == 'system') && !isAlreadySeen))) {
                // this.props.actions.c

                // console.log("changeMessageToSeen", msg.seen)

                let newMessengerId = msg.messenger?._id ?? msg.messenger

                this.changeMessageToSeen(newMessengerId, msg._id, msg.sequence)
            }
            // if (!this.tempLastSeen || (this.tempLastSeen < msg._id)) {
            //     // UPDATE MESSENGER LAST SEEN
            //     this.tempLastSeen = msg._id
            //     this.updateLastSeenOnServer(msg._id)
            // }
            // });
        }
        // viewableItems will show you what items are in view
    }

    // onViewableItemsChanged = ({ viewableItems }) => {
    //     if (this.state.myId) {
    //         viewableItems.forEach(viewableItem => {
    //             if (viewableItem.item.myId != this.state.myId && viewableItem.item.status != 2 && viewableItem.item._id) {
    //                 // this.props.actions.c
    //                 this.changeMessageToSeen(viewableItem.item._id)
    //             }
    //             if (!this.tempLastSeen || (this.tempLastSeen < viewableItem.item._id) && viewableItem.item._id) {
    //                 // UPDATE MESSENGER LAST SEEN
    //                 this.updateLastSeenOnServer(viewableItem.item._id)
    //             }
    //         });
    //     }
    //     // viewableItems will show you what items are in view
    // }

    isInViewport(id, offset = 0) {
        if (!id) return false;
        let element = document.getElementById("msg-" + id)
        let messageContainerTop = getBoundingClientRect(this.messagesContainer).top
        if (element) {
            const top = element.getBoundingClientRect().top;
            return (top - offset) >= (messageContainerTop - 30);
        }
    }

    changeMessageToSeen(messengerId, messageId, sequence) {
        // let messengerId = this.props.route?.params?.id
        // console.log('changeMessageToSeen', messengerId, messageId)
        this.props.actions.changeMessage(messengerId, messageId, { status: 2, [`seen.${this.state.myId}`]: new Date() })
        this.props.actions.changeOneLastSeen(messengerId, messageId, sequence, this.state.myId)
        this.sendSeenToServer(messengerId, messageId, sequence)
    }

    sendSeenToServer = (messengerId, messageId, sequence) => {
        if (SocketServices.socket?.connected) {

            let senderHub = this.state.myActiveRef?.hub

            SocketServices.emit('messageSeen', { messengerId, messageId, sequence, senderHub: (senderHub?._id ?? senderHub) }, null, (ok, err) => {
            });
        } else {
            setTimeout(() => {
                this.sendSeenToServer(messengerId, messageId, sequence)
            }, 2000);
        }
    }

    // updateLastSeenOnServer = (time, tryTime, messageId, messengerId) => {
    //     setTimeout(() => {
    //         if (SocketServices.socket?.connected) {
    //             SocketServices.emit('messengerSeenUpdate', { messengerId, messageId }, null, (ok, err) => {
    //             })
    //         } else {
    //             if (tryTime < 10) {
    //                 this.updateLastSeenOnServer(time + 5, tryTime + 1, messageId, messengerId)
    //             }
    //         }
    //     }, time * 1000);
    // }

    // sendNotifToServer = (messengerId) => {
    //     if (SocketServices.socket?.connected) {
    //         SocketServices.emit('notif', { type: 'isTyping', messengerId }, null, (ok, err) => {
    //         });
    //     } else {
    //         setTimeout(() => {
    //             this.sendNotifToServer(messengerId)
    //         }, 2000);
    //     }
    // }

    scrollToBottom = (smooth) => {
        // console.log("scrollToBottom")
        setTimeout(() => {
            if (this.messagesContainer) {
                this.messagesContainer.scrollTo({ top: (this.messagesContainer.scrollHeight + 100), behavior: smooth ? 'smooth' : 'auto' })
            } else {
                this.scrollToBottom()
            }
        }, 1);
        // this.messagesEndRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    newMessages() {

        let notifcount = this.props.inbox?.messengers?.[this.props.messenger._id]?.count

        return (
            <div ref={el => this.newMessagesBox = el}>
                <p className="text-center text-smaller w-100 py-1 mt-3" style={{ backgroundColor: '#fff', color: '#789', borderRadius: 4 }}>{notifcount != 0 ? notifcount : ''} New Messages</p>
            </div>
        )
    }

    showAttachments = (status) => {
        if (this.MessengerAttachments) {
            this.MessengerAttachments.showAttachments(status)
        }
    }

    showTopics = (status) => {
        if (this.MessengerTopics) {
            this.MessengerTopics.showTopics(status)
        }
    }

    showDropZone = (e, type) => {
        this.showDropZoneTime = new Date().getTime()
        let messenger = this.props.messenger
        let potentialUser = this.props.potentialUser
        if ((messenger || potentialUser) && !this.state.showDropZone) {
            this.onFilesOver(e)
        }
    }

    onFilesOver = (e) => {
        let showCompressionOption = false
        let showDropZone = false
        if (e.dataTransfer?.items) {
            showDropZone = true
            Object.values(e.dataTransfer.items).forEach(element => {
                if (element.type.startsWith('image/') || element.type.startsWith('video/')) {
                    showCompressionOption = true
                }
                if (element.type.startsWith('text/uri-list')) {
                    showDropZone = false
                }
            });
        }
        this.setState({ showCompressionOption, showDropZone })
        // this.hideDropZone()
        // this.MessengerDropModal.showModal(files)
        // this.setState({ droppedFiles: files })
    }

    hideDropZone = () => {
        if (this.state.showDropZone) {
            setTimeout(() => {
                let now = new Date().getTime()
                if ((now - this.showDropZoneTime) > 95) {
                    this.setState({ showDropZone: false })
                }
            }, 100);
        }
    }

    onDrop = (files, withCompression) => {
        this.hideDropZone()
        this.MessengerDropModal.showModal(files, withCompression)
        // this.setState({ droppedFiles: files })
    }

    passAttachFiles = (files, withCompression, caption) => {
        this.MessengerDropModal.showModal(files, withCompression, caption)
    }

    startRecording = () => {
        this.setState({ showRecording: true })
    }

    showStickersList = () => { }

    onStickerSelect = (type, prop) => {
        if (type == 'emoji') {
            let input = this.input
            // input.focus();
            this.insertAtCursor(input, prop.emoji)
            // let sel = document.selection.createRange();
            // sel.text = myValue;
        }
    }

    insertAtCursor(myField, myValue) {
        let text = this.state.text
        // if (myField.id == document.activeElement.id) {
        myField.focus();
        // }
        //IE support
        if (document.selection) {
            // myField.focus();
            let sel = document.selection.createRange();
            // sel.text = myValue;
        }
        //MOZILLA and others
        else if (myField.selectionStart || myField.selectionStart == '0') {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;
            text = myField.value.substring(0, startPos)
                + myValue
                + myField.value.substring(endPos, myField.value.length);
        } else {
            text += myValue;
        }
        this.setState({ text }, () => {
            myField.selectionStart = startPos + myValue.length
            myField.selectionEnd = startPos + myValue.length
            // let sel = myField.createRange();
            // sel.selectionStart = startPos+1
            // sel.selectionEnd = startPos+1
            // myField.clearSelection()
            // textArea.current.selectionStart = startPos
            // myField.setSelectionRange(startPos,startPos) //= startPos+1
            // myField.selectionEnd = startPos+1
        })
    }

    onMoreVisibilityChanged = (isIntersecting) => {
        this.setState({ hideToppestDate: isIntersecting })
    }

    openInfoMessenger = () => {
        // console.log('openInfoMessenger', this.props.setData)
        if (this.props.setData) {
            this.props.setData('messengerInfo', !this.props.messengerInfo, 'Messenger')
        }
        // this.setState({ messengerInformation: !this.state.messengerInformation })
    }

    createTopic = (messenger) => {
        let users = []
        let data = {}
        if (this.form1) {
            users = this.form1.getForm()
            data.users = users
        }
        data.topic = this.state.topicName
        data.messenger = messenger
        this.props.createTopic(data)
    }

    setData = () => {
        let messengerName = this.props.messenger?.name
        let messengerUsers = []
        for (let i = 0; i < this.props.messenger?.users?.length; i++) {
            messengerUsers.push(this.props.messenger?.users[i]?.hub?._id)
        }
        this.setState({ messengerName, messengerUsers })
    }

    changeStage = (stage) => {
        this.stageManager.changeStage(stage)
    }

    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }

    editGroup = (messengerId, info) => {
        let data = {}
        data.messengerName = info.name
        data.messengerUsers = info.users
        data._id = messengerId
        HttpServices.request('createGroupMessenger', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
        })
    }

    deleteMessage = (message, messenger, hub, type, cb) => {
        HttpServices.request('deleteMessage', { message, messenger, hub, type }, (fetchResult, fetchError) => {
            cb()
        })
    }

    editMessageAction = (item) => {
        // let onEdit=this.state.onEdit
        let messengerId = this.props.messenger._id
        let onEdit = this.state.onEdit
        onEdit[messengerId] = item
        this.setState({ onEdit }, () => {
        })
    }

    editMessage = (message, messenger, newMsg) => {
        HttpServices.request('editMessage', { message, messenger, newMsg }, (fetchResult, fetchError) => {
            let onEdit = this.state.onEdit
            onEdit[this.props.messenger._id] = null
            this.setState({ onEdit, text: '', row: 1 }, () => {
                let input = this.input
                input.style.height = '36px';
                input.style.height = 'inherit';
                input.style.height = (input.scrollHeight) + "px";
                let height = getBoundingClientRect(input).height
                this.setState({ inputHeight: height })
                if (fetchError) {
                    return
                }
                // let msg = fetchResult.info
                // if (!Array.isArray(msg)) {
                //     msg = [msg]
                // }
                // store.dispatch(actions.updateMessages(fetchResult.info.messenger, msg))
            })
        })
    }

    cancelEditMessage = () => {
        let onEdit = this.state.onEdit
        onEdit[this.props.messenger._id] = null
        let input = this.input
        this.setState({ onEdit, text: '', row: 1, },
            () => {
                input.style.height = '36px';
                input.style.height = 'inherit';
                input.style.height = (input.scrollHeight) + "px";
                let height = getBoundingClientRect(input).height
                this.input.focus()
                this.setState({ inputHeight: height })
            })
    }

    roomCall = (messenger, type) => {
        let data = {}
        data.messenger = messenger._id
        data.type = type
        HttpServices.request('roomCall', data, (fetchResult, fetchError) => {
            if (!Array.isArray(fetchResult.info)) {
                fetchResult.info = [fetchResult.info]
            }
            store.dispatch(actions.addOutgoingCall(fetchResult.info))
        })
    }
    showActions = () => {

    }
    selectMessage = (item) => {
        if (!this.state.showSelect) {
            this.setState({ showSelect: true })
        }
        let selectList = this.state.selectList
        if (selectList.includes(item._id)) {
            let index = selectList.indexOf(item._id)
            selectList.splice(index, 1)
        }
        else {
            selectList.push(item._id)
        }
        this.setState({ selectList })
    }

    cancelSelect = () => {
        this.setState({ showSelect: false, selectList: [] })
    }

    // handleKeyDown = (e) => {
    //     if (e.key === 'Enter') {
    //         this.sendTextMessage();
    //     }
    // };

    handleKeyDownChange = (e) => {
        if (e.keyCode === 13 && e.shiftKey) {
            let input = this.input
            let row = this.state.row
            row = row + 1
            e.preventDefault();
            this.setState({ text: `${this.state.text}\n`, row }, () => {
                input.focus()
                // this.sendNotifToServer(this.props.messenger._id)
                input.style.height = 'inherit';
                input.style.height = (input.scrollHeight) + "px";
                let height = getBoundingClientRect(input).height
                if (!e.style) {
                    e.style = {}
                }
                e.style.height = height + 'px'
                this.setState({ inputHeight: height })
            });
        }
        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            if (this.state.text && this.state.text != '') {
                let onEdit = this.state.onEdit
                if (onEdit && this.props.messenger && this.props.messenger._id && onEdit[this.props.messenger._id]) {
                    this.editMessage(this.state.onEdit[this.props.messenger._id]._id, this.props.messenger._id, this.state.text)
                }
                else {
                    this.sendTextMessage()
                }
            }
        }
    }


    replyAction = (key, data) => {
        switch (key) {
            case 'delete': {
                this.deletemessage.showModal()
                break;
            }
            default:
                break
        }
    }

    selectOptions = (key) => {
        // if (key == 'forward') {
        //     this.props.openMembers()
        //     this.props.setData('forwardList', this.state.selectList)
        // }
    }

    setInputId = (id) => {
        this.setState({ inputId: id })
    }



    openImageModal = (address) => {
        this.setState({ imageAddress: address })
        this.ShowImage.showModal()
    }

    supportAssigne = () => {
        HttpServices.request('assigneSupport', { messenger: this.props.messenger._id, assignee: (this.props.user?.info?._id ?? this.props.tempUser) }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }

            // console.log("fetchResult", fetchResult.info)

            let messenger = createMessengerInfo(fetchResult.info, this.state.myId)

            // console.log("messenger!!", messenger)
            store.dispatch(actions.updateMessengers([messenger]))
            // messenger['**name'] = messenger.name
            // console.log("supportAssigne")
            this.props.setMessenger(messenger)
            // let messengers = Array.isArray(fetchResult.info) ? fetchResult.info : [fetchResult.info]
            // store.dispatch(actions.updateMessengers(messengers))

        })
    }

    translateStatus = (status) => {
        let newStatus
        switch (status) {
            case 0:
                newStatus = 'not active'
                break;

            case 1:
                newStatus = 'pending'
                break;

            case 2:
                newStatus = 'waiting for awnser'
                break;

            case 3:
                newStatus = 'awnsered'
                break;

            case 4:
                newStatus = 'done'
                break;

            default:
                break;
        }
        return newStatus
    }

    detectDirection(text) {
        const rtlCharRegex = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/; // Unicode range for RTL scripts
        return rtlCharRegex.test(text) ? 'rtl' : 'ltr';
    }

    setMyActiveRef = (item) => {
        // console.log(item)
        this.setState({ myActiveRef: item })
    }


    setTopic = (topic) => {

        // console.log(topic)
        let final = JSON.parse(JSON.stringify(topic))
        let parent = topic.parent
        parent = parent?._id ?? parent

        if (parent && Array.isArray(this.props.messengers?.list)) {
            parent = this.props.messengers.list.filter((a) => a._id == parent)[0]
        }

        final.parent = parent

        if (parent) {
            final.topics = parent.topics

            final['**name'] = parent['**name']
            final['**image'] = parent['**image']
            final['**refs'] = parent['**refs']
            final['**myValidRefs'] = parent['**myValidRefs']
        }

        if (this.messengerTopics) {
            this.messengerTopics.hide()
        }

        this.props.setMessenger(final)



    }


    openTopics = () => {
        this.TopicsView.openSidebar()
    }
    closeTopic = () => {
        this.TopicsView.close()
    }


    render() {
        // console.log('this.props.adppler', this.props.applet)
        // console.log('this.props.currentApplet', this.props.currentApplet)
        let hasText = this.state.text && this.state.text != ''
        let deafultImage = this.props.messenger?.type == 'group' ? 'group' : 'profile'
        let notifcount = this.props.inbox?.messengers?.[this.props.messenger?._id]?.count


        return (
            <div ref={el => this.messenger = el} id={'messenger-' + this.state.messengerId} className="messenger flex-column d-flex h-100 window-content-radius" style={{}} onDragEnter={(e) => this.showDropZone(e, '0')}  >
                {/* {this.props.isApplet && this.props.applet.settings && this.props.applet.settings.type && this.props.applet.settings.type == 'support' && */}
                {/* <FixedView ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={0} xOffset={0} zIndex={10} >
                    <div className='shadow-2 px-3 py-1 br-8' style={{ backgroundColor: "#fff", width: "max-Content" }}>
                        <div className="d-flex flex-column">
                            <p>admins</p>
                            <p>admins</p>
                        </div>
                    </div>
                </FixedView> */}
                {/* } */}

                {!(this.props.messenger || this.props.potentialUser) && (
                    <div className='text-center w-100 h-100 flexcc flex-column' style={{}}>
                        <img src='/assets/icons/portals/folder2.svg' width={50} style={{ filter: 'grayscale(1)', opacity: 0.5 }} alt="" />
                        <p className='px-4 py-2 br-100 font-size-14 weight-400 main-c7' style={{ background: 'rgb(255, 255, 255, 0.7)' }}>{translate("Select a chat to start messaging")}</p>
                    </div>
                    // <div className='text-center w-100' style={{ paddingTop: 100 }}>
                    //     <img src='/assets/sorry.svg' width={300} />
                    //     <p className="mt-2" style={{ fontWeight: 'bold', fontSize: 20, color: "#333" }}>{translate('messenger.Chat is Not Selected')}</p>
                    //     <p className='mt-1' style={{ fontSize: 14, color: "#666" }}>{translate("messenger.Select a connection to start the chat")}</p>
                    // </div>
                )}
                {(this.props.messenger || this.props.potentialUser) && (
                    <>
                        {/* {this.state.parents[this.props.messenger?._id]?.length != 0 && ( */}
                        <>
                            <div className={"w-100 h-100 position-relative m-0 p-0 flex-1 "} style={{}}>
                                <div className="w-100 p-0 h-100 detail order-lg-1 order-2  " style={{ scrollSnapAlign: 'start' }}>
                                    {/* header */}
                                    <div className="detail-header pt-1 pb-1 px-2 flexcb window-content-radius-top" style={{ borderBottom: '1px solid #f2f2f2', backgroundColor: '#ffffff', zIndex: 5 }}>
                                        <div className="position-relative w-100">
                                            <div className=" flexc w-100 py-1">

                                                {this.props.showBack && (
                                                    <button onClick={() => this.props.closeOne()} className="mt-2 mrd-3 ">
                                                        <img src={'/images/nexts.png'} height="16px" className={this.props.settings.language == 'fa' ? "" : " rotate-180"} />
                                                    </button>
                                                )}
                                                <div className="w-100 flexcb"  >
                                                    <div className="flexc" onClick={this.openInfoMessenger} ref={el => this.firstCurrentNode = el} style={{ cursor: 'pointer' }}>
                                                        <div className="flexcc">
                                                            <img src={imageAddress(this.state.messengerInfo?.image, deafultImage, 'small')} style={{ height: 36, width: 36, objectFit: 'cover', borderRadius: 20 }} alt="" />
                                                        </div>
                                                        <div className="mx-2 ">

                                                            <div className="d-flex flex-column">

                                                                <p className=" m-0 font-size-14" style={{ fontWeight: 500, color: "#333" }}>{this.state.messengerInfo?.name}
                                                                    {this.state.messengerInfo?.topicName && (
                                                                        <span className="m-0 pld-2" style={{ fontWeight: 500, color: "#007aff" }}>[ {this.state.messengerInfo?.topicName} ]</span>
                                                                    )}
                                                                </p>
                                                            </div>


                                                            <div className="flexc">

                                                                {this.props.messengers.object[this.props.messenger?._id]?.activity?.isTyping?.length > 0 ? (
                                                                    <p style={{ fontSize: 12, color: '#3b53ed' }}>{translate('messenger.is typing')}</p>
                                                                ) : (
                                                                    <>
                                                                        {(this.props.messenger?.type != 'group' && this.props.messenger?.type != 'support' && this.state.hubStatus) && (


                                                                            <p className="text-smallest " style={{ color: '#789', lineHeight: 1, marginTop: 1 }}>{this.state.hubStatus?.status == 1 ? translate('messenger.Status Online') : translate('messenger.Status Ofline last seen: ') + (this.state.hubStatus?.la ? this.state.hubStatus?.la : '')}</p>

                                                                        )}
                                                                    </>
                                                                )}


                                                            </div>


                                                        </div>
                                                    </div>
                                                    {/* {console.log('aaaaaaaadnikfnhcdnfck', this.props.messenger)} */}
                                                    {this.props.messenger && ((this.props.messenger.type && this.props.messenger.type == 'support')) ? (

                                                        <div className="flexc">
                                                            {(this.props.adminView && this.props.messenger.assignee) &&
                                                                <div className="flexc mx-2">
                                                                    <p className="font-size-12 main-c2 weight-500">{translate('Assignee')}:&nbsp;</p>
                                                                    <p className="font-size-12 main-c2 weight-500">{this.props.messenger.assignee?.hub?.fullname}</p>
                                                                </div>
                                                            }
                                                            {/* {item.type && */}
                                                            <div className="flexc">
                                                                {/* <p className="font-size-12 main-c2 weight-400">{translate('Status')} :&nbsp;</p> */}
                                                                <p className="font-size-12 main-c2 weight-500 br-20 px-2 py-1" style={{ backgroundColor: '#f0f0f0' }}>{this.translateStatus(this.props.messenger?.status)}</p>
                                                            </div>
                                                            {/* } */}
                                                        </div>
                                                    ) : (
                                                        <div className="transition">
                                                            {this.state.showSelect == true ? (
                                                                <div className="flexc">
                                                                    {this.state.selectOption.map((prop, index) => {
                                                                        return (
                                                                            <button className='flexcb w-100 br-5 px-2' onClick={() => this.selectOptions(prop.key)}>
                                                                                <img width={24} src={prop.icon} alt="" />
                                                                            </button>
                                                                        )
                                                                    })}
                                                                    <button className="flexcc px-3 br-5 mld-3 gray-btn" style={{ paddingTop: '6px', paddingBottom: '6px' }} onClick={() => this.cancelSelect()}>
                                                                        <p className="main-c4">{translate('messenger.Cancel')}</p>
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <div className="flexc">
                                                                    <button className="mx-3 icon-hover flexcc" onClick={() => this.roomCall(this.props.messenger, 'video')}>
                                                                        <img width={24} src="/assets/icons/messenger/video.svg" />
                                                                    </button>
                                                                    <button className="icon-hover flexcc" onClick={() => this.roomCall(this.props.messenger, 'audio')}>
                                                                        <img width={24} src="/assets/icons/messenger/phone.svg" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* message list */}
                                    {!this.state.hideToppestDate && this.state.toppestDate ? (
                                        <div className="flexcc w-100" style={{ position: 'absolute', top: 55, left: 0, zIndex: 1 }}>
                                            <div className="px-2 shadow-1   " style={{ backgroundColor: '#fff', borderRadius: 20 }}>
                                                {/* {console.log("moment(this.state.toppestDate).format('DD MMMM')", moment(this.state.toppestDate).format('DD MMMM'))} */}
                                                <p className="px-2 py-1 font-size-12" style={{ color: "#777" }}>{moment(this.state.toppestDate).format('DD MMMM') ?? ''}</p>
                                            </div>
                                        </div>
                                    ) : ''}
                                    <div ref={el => this.messagesContainer = el} className=" w-100 pb-2 sc-5 position-relative" style={{ justifyContent: 'flex-end', overflow: 'auto', height: (this.state.onEdit && this.props.messenger && this.props.messenger._id && this.state.onEdit[this.props.messenger._id]) ? `calc(100% - ${52.8 + 12.8 + 48.8 + this.state.inputHeight}px)` : `calc(100% - ${52.8 + 12.8 + this.state.inputHeight}px)` }}>
                                        <div className="px-3 w-100  ">
                                            <div className="pb-2 pt-1 w-100 ">
                                                {this.props.askForForm && !this.props.messenger && (
                                                    <div className="px-3 py-3" style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                                                        <p className="text-smaller px-1 mb-2">{translate('Welcome-to-bot-support-service')}</p>
                                                        <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"modern"} inputClass={"modern-input"} />
                                                        <button onClick={() => this.submitForm()} className="white w-100 px-2 py-2 mt-2" style={{ borderRadius: 8, background: 'linear-gradient(to left,#7b00f7,#a912eb)' }}>{translate('messenger.Start the chat')}</button>
                                                    </div>
                                                )}
                                                {this.state.isOnLast && (
                                                    <MessageNoMoreMessage onMoreVisibilityChanged={this.onMoreVisibilityChanged} colors={this.props.colors} />
                                                )}
                                                {/* {this.state.messengerInformation && (
                                                    // <StagesManager ref={el => this.stageManager = el} fast={true}>
                                                    //     <div stage={0} stageName={'info'} className="w-100 flexcc " style={{ position: 'absolute', left: 0, top: 30, zIndex: '2', }}>
                                                    //         <div className="w-100 px-3 py-3" style={{ backgroundColor: '#fff', }}>
                                                    //             <div className="w-100 px-3 py-3" onClick={() => this.changeStage('createTopic')}>
                                                    //                 <button>
                                                    //                     <p style={{ fontSize: '16px' }}>Create Topic</p>
                                                    //                 </button>
                                                    //             </div>
                                                    //             {(this.props.messenger?.type == 'group' || this.props.messenger?.type == 'support') && (
                                                    //                 <div className="w-100 px-3 py-3" onClick={() => { this.changeStage('editGroup') }}>
                                                    //                     <button>
                                                    //                         <p style={{ fontSize: '16px' }}>Edit Group</p>
                                                    //                     </button>
                                                    //                 </div>
                                                    //             )}
                                                    //         </div>
                                                    //     </div>
                                                    //     <div stage={1} stageName={'createTopic'} className="w-100 flexcc " style={{ position: 'absolute', left: 0, top: 45, zIndex: '2', }}>
                                                    //         <div className="w-100 px-3 py-3" style={{ backgroundColor: '#fff', }}>
                                                    //             <TextInput data={this.state.topicName} changeValue={this.changeValue} header={{ key: 'topicName', information: { rows: 1, placeholder: '{{lang}}Topic Name' } }} />
                                                    //             {this.props.messenger?.type == "group" ? (<FormViewer ref={el => this.form1 = el} headers={this.state.header} inputClass={'modern-input'} />) : ''}
                                                    //             <div onClick={() => this.createTopic(this.props.messenger._id)}>
                                                    //                 <button style={{ backgroundColor: '#00A4bb' }}>
                                                    //                     <p style={{ fontSize: '16px' }}>Submit</p>
                                                    //                 </button>
                                                    //             </div>
                                                    //         </div>
                                                    //     </div>
                                                    //     <EditGroup stage={1} stageName={'editGroup'} messenger={this.props.messenger} editGroup={this.editGroup} openUserInfo={this.openUserInfo} />
                                                    // </StagesManager>
                                                    <GroupInfo />
                                                )} */}

                                                {this.props.messengers.messages[this.props.messenger?._id]?.map((prop, index) => {

                                                    // console.log("!*!", this.props.messenger?._id)
                                                    // console.log("!!", this.props.messengers.messages[this.props.messenger?._id])
                                                    let nextMsg = this.props.messengers.messages[this.props.messenger?._id][index + 1]
                                                    let prevMsg = this.props.messengers.messages[this.props.messenger?._id][index - 1]
                                                    let days
                                                    if (nextMsg) {
                                                        days = (moment(prop.cDate).endOf('day')).diff((moment(nextMsg.cDate).endOf('day')), 'days')
                                                    }
                                                    return (
                                                        <div key={String(prop?._id)}>
                                                            {(days > 0 || !nextMsg) && (
                                                                <div className="w-100 flexcc mt-2">
                                                                    <div className="px-2 shadow-1" style={{ backgroundColor: '#fff', borderRadius: 20 }}>
                                                                        <p className="px-2 py-1 font-size-12" style={{ color: "#777" }}>{moment(prop.cDate).format('DD MMMM')}</p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <MessageBox openImageModal={this.openImageModal} adminView={this.props.adminView} messengerId={this.state.messengerId} observer={this.observer} showSelect={this.state.showSelect} selectList={this.state.selectList} selectMessage={this.selectMessage} updateInput={this.updateInput} editMessageAction={this.editMessageAction} deleteMessage={this.deleteMessage} chatUsers={this.state.chatUsers} chatInteractive={this.state.chatInteractive} myId={this.state.myId} key={prop._id} data={prop} messenger={this.props?.messenger} onViewableItemsChanged={this.onViewableItemsChanged} setInputId={this.setInputId} isApplet={this.props.isApplet} applet={this.props.applet} colors={this.props.colors} myValidRefs={this.state.myValidRefs} myActiveRef={this.state.myActiveRef} />
                                                            {this.state.showNewMessagesBox == prop._id && prop._id != null && (
                                                                this.newMessages()
                                                            )}
                                                        </div>
                                                    )
                                                }).reverse()}
                                                <div className="flexcc w-100 " >
                                                    <Modal ref={el => this.userInfoModal = el} centerMode={true} >
                                                        <div className="flexcc br-10" style={{ backgroundColor: '#fff', }}  >
                                                            <div className="p-2" style={{ backgroundColor: '#F70C0C', cursor: 'pointer', color: '#fff', borderRadius: '5px' }} onClick={() => this.removeUser(this.state.userInfo)}>
                                                                {translate('messenger.Remove')}
                                                            </div>
                                                        </div>
                                                    </Modal>
                                                </div>
                                                {this.state.isLoadingInfo && (
                                                    <div className="flexcc w-100  " style={{ alignItems: 'center', position: 'absolute', top: 60, zIndex: 0, left: 0 }}>
                                                        <div className="flexcc" style={{ backgroundColor: '#fff', borderRadius: 40, width: 34, height: 34, padding: 4, boxShadow: '0px 0px 10px #10101010' }}>
                                                            <div className="flexcc flex-column loader-container">
                                                                <Loader
                                                                    type="Oval"
                                                                    color="#007aff"
                                                                    height="25"
                                                                    width="25"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div ref={el => this.messagesEndRef = el} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* message box */}
                                    {this.state.onEdit && this.props.messenger && this.props.messenger._id && this.state.onEdit[this.props.messenger._id] ?
                                        <div className="  w-100 window-content-radius-bottom position-relative" style={{ padding: '6px 0px 6px 0px', position: 'sticky', left: 0, bottom: 0, zIndex: 1, borderTop: '1px solid #eee', backgroundColor: "#fff" }}>
                                            <div className="flexc w-100">
                                                <div className="w-100 flexc mx-2 px-1 position-relative" style={{ padding: '0px 0px', borderRadius: 10, }}>
                                                    <img src="/assets/icons/pencil-blue.svg" width={30} style={{ marginRight: this.props.language == 'fa' ? '14px' : '24px', marginLeft: this.props.language == 'fa' ? '24px' : '14px' }} />
                                                    <div className="" style={{ backgroundColor: '#0085ff', width: '4px', height: '36px', borderRadius: '100px', marginRight: '4px', }}></div>
                                                    <div className="position-relative flex-1 flexc">
                                                        <p className="w-100 mt-0" style={{ padding: '8px 5px', outline: 'none', resize: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 14, height: '60', maxHeight: 100, color: "#444", minHeight: '36px' }} >
                                                            {((this.props.messengers.messages[this.props.messenger?._id]).filter((e) => e._id == this.state.onEdit[this.props.messenger._id]._id))[0].text}
                                                        </p>
                                                    </div>
                                                    <button onClick={() => { this.cancelEditMessage() }}>
                                                        <img src="/assets/icons/close.svg" width={24} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        : <div></div>
                                    }
                                    <div className="  w-100 window-content-radius-bottom position-relative" style={{ padding: '6px 0px 6px 0px', position: 'sticky', left: 0, bottom: 0, zIndex: 1, borderTop: '1px solid #eee', backgroundColor: "#fff" }}>
                                        {(notifcount > 0) && (
                                            <div onClick={() => this.scrollToBottom()} className="flexcc shadow-2" style={{ position: 'absolute', top: -37, right: 10, zIndex: 10, backgroundColor: '#fff', borderRadius: 30, padding: '5px 8px', width: 32, height: 32 }}>
                                                <div className="flexcc" style={{ position: 'relative' }}>
                                                    <div style={{ position: 'absolute', top: -20, backgroundColor: '#007aff', borderRadius: 30, padding: '2px 8px', }}>
                                                        <p className="text-smallest white">{notifcount}</p>
                                                    </div>
                                                    <img src="/images/nexts.png" className="rotate-90 opacity-5" width={16} />
                                                </div>
                                            </div>
                                        )}
                                        <div className="flexc w-100">
                                            <div className="w-100 flexc mx-2 px-1 position-relative" style={{ padding: '0px 0px', borderRadius: 10, backgroundColor: '#f4f4f4' }}>
                                                {/* {console.log('thisssssprops', this.props)} */}
                                                {(!this.state.hideAssigne && this.props.messenger?.type == 'support' && !this.props.messenger?.assignee && this.props.isApplet) && (
                                                    <div className='px-3 py-2 br-8 assign-box' style={{ position: 'absolute', bottom: 50, right: 0, zIndex: 10, width: "max-Content" }}>
                                                        <div className="flexcc flex-column">
                                                            <p className="font-size-15 main-c2 weight-600">{translate('Assign to me?')}</p>

                                                            <div className="flexc w-100 pt-3" style={{ justifyContent: 'flex-end' }}>
                                                                <div className="flexc mrd-2">
                                                                    <ButtonAnimated
                                                                        iconwidth='24px'
                                                                        // onClick={}
                                                                        onClick={() => this.setState({ hideAssigne: true })}
                                                                        title={translate('Cancel')}
                                                                        textColor={'#a3a2b0'}
                                                                        bg={'#eee'}
                                                                    />
                                                                </div>
                                                                <div className="flexc mld-2">
                                                                    <ButtonAnimated
                                                                        iconwidth='24px'
                                                                        onClick={() => this.supportAssigne()}
                                                                        title={translate('Assign')}
                                                                        icon='/assets/icons/applets/drive/tick.svg'
                                                                        textColor={'#fff'}
                                                                        bg={`linear-gradient(90deg, #1f89eb, #2492f6)`}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {/* <img src="/assets/icons/close.svg" className="mld-3" width={'18px'} /> */}
                                                        </div>
                                                    </div>
                                                )}


                                                <MessengerTopics ref={el => this.messengerTopics = el} openTopics={this.openTopics} width={this.props.width} messengerInfo={this.props.messengerInfo} openInfoMessenger={this.openInfoMessenger} setMessenger={this.props.setMessenger} messenger={this.props.messenger} topics={this.props.messenger?.topics} height='100%' colors={this.props.colors} setTopic={this.setTopic} />

                                                {/* actions*/}
                                                {/* {console.log('this.props.currentApplet', this.props.applet)} */}
                                                {/* {console.log('this.props.applet.actions34',this.props.applet?.actions)} */}
                                                {/* {this.props.applet?.settings?.type == 'support' ? ( */}
                                                {/* <button onClick={() => { this.showActions() }} className="px-1 flexcc">
                                                     <img src={'/assets/icons/applets/messenger/actions-loarder.svg'} style={{ transition: '0.3s all' }} height={30} />
                                                         </button> */}

                                                <>
                                                    {(Array.isArray(this.props.applet?.actions) && this.props.applet?.actions?.length != 0 && this.props.messenger?.type == 'support') ? (
                                                        <div className=' flexcc' style={{}}>
                                                            <ActionsBtn page={{ actions: this.props.applet?.actions }} applet={this.props.applet} data={this.props.data} index={this.props.index} actions={this.state.actions} actionClicked={this.actionClicked} language={this.props.language} currentRecord={this.props.currentRecord} currentRecordStage={this.props.currentRecordStage} changeRecordStage={this.props.changeRecordStage} setCurrentRecordStage={this.props.setCurrentRecordStage} colors={this.props.colors} />
                                                        </div>
                                                    ) : <></>}
                                                </>

                                                {(!(this.state.myValidRefs?.length > 1) || this.state.myActiveRef) && (

                                                    <button onClick={() => { this.showAttachments() }} className=" flexcc">
                                                        <img src={'/assets/icons/messenger/paperclip.svg'} style={{ transition: '0.3s all' }} height={30} />
                                                    </button>
                                                )}


                                                {this.state.myValidRefs?.length > 1 && (
                                                    <div className="">
                                                        <MessengerSelectMyRef openTopics={this.props.openTopics} width={this.props.width} messengerInfo={this.props.messengerInfo} openInfoMessenger={this.openInfoMessenger} setMessenger={this.props.setMessenger} myActiveRef={this.state.myActiveRef} myValidRefs={this.state.myValidRefs} height='100%' colors={this.props.colors} setMyActiveRef={this.setMyActiveRef} />
                                                    </div>
                                                )}
                                                <div className="position-relative flex-1 flexc">
                                                    {/* <div className="position-absolute w-100" style={{ zIndex: -1, bottom: 0 }}>
                                                <textarea ref={el => this.inputShadow = el} rows={1} value={this.state.text} className="w-100 mt-0" style={{ opacity: 0, padding: '8px 5px', outline: 'none', resize: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 14, height: '60', maxHeight: 100, color: "#444", minHeight: '36px' }} placeholder={translate("messenger.Message")} />
                                            </div> */}
                                                    {(!(this.state.myValidRefs?.length > 1) || this.state.myActiveRef) && (

                                                        <textarea id={"input-" + this.state.inputId} ref={el => this.input = el} autoFocus={true} rows={this.state.row} value={this.state.text} onKeyDown={e => this.handleKeyDownChange(e)} onChange={(e) => this.updateInput(e.target)} className="w-100 mt-0" style={{ padding: '8px 5px', outline: 'none', resize: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 14, height: this.state.inputHeight, maxHeight: 100, color: "#444", minHeight: '36px', direction: this.state.textBoxDirextion ?? 'ltr' }} placeholder={translate("messenger.Message")} />
                                                    )}

                                                </div>
                                                <StickersView onSelect={this.onStickerSelect} type='messenger' colors={this.props.colors} />
                                                <div className="flexcc" style={{ width: 30 }}>
                                                    {!hasText && (
                                                        <div className="px-1 flexcc" >
                                                            <MessengerRecording action={this.props.action} tempFile={"file"} createMessage={this.createMessage} sendFile={this.sendFileMessage} messengerId={this.props.messenger?._id} type={"message"} colors={this.props.colors} />
                                                        </div>
                                                    )}
                                                    {hasText && (
                                                        <>
                                                            {this.state.onEdit && this.props.messenger && this.props.messenger._id && this.state.onEdit[this.props.messenger._id] ? (
                                                                <button onClick={() => { if (hasText) { this.editMessage(this.state.onEdit[this.props.messenger._id]._id, this.props.messenger._id, this.state.text) } }} className="px-1 flexcc">
                                                                    <img src={'/assets/icons/messenger/send.svg'} style={{ opacity: hasText ? 1 : 0.5, filter: hasText ? '' : 'saturate(0%)', transition: '0.3s all' }} height={30} />
                                                                </button>
                                                            ) : (
                                                                <button onClick={() => { if (hasText) { this.sendTextMessage() } }} className="px-1 flexcc">
                                                                    <img src={'/assets/icons/messenger/send.svg'} style={{ opacity: hasText ? 1 : 0.5, filter: hasText ? '' : 'saturate(0%)', transition: '0.3s all' }} height={30} />
                                                                </button>
                                                                // <button onClick={() => { if (hasText) { this.sendTextMessage() } }} onKeyDown={(e) => { if (e.keyCode === 13) { this.sendTextMessage() } }} className="px-1 flexcc">
                                                                //     <img src={'/assets/icons/messenger/send.svg'} style={{ opacity: hasText ? 1 : 0.5, filter: hasText ? '' : 'saturate(0%)', transition: '0.3s all' }} height={30} />
                                                                // </button>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <MessengerTopics ref={el => this.MessengerTopics = el} height='100%'/> */}
                                        <MessengerAttachments language={this.props.language} ref={el => this.MessengerAttachments = el} height='100%' passAttachFiles={this.passAttachFiles} colors={this.props.colors} />
                                        {/* {this.state.showAttachments && (
                                <div className="flexc px-2 w-100" style={{ overflow: "auto" }} >
                                    {this.state.attachmentsList.map((prop, index) => {
                                        return (
                                            <button className="flexcc flex-column my-0 mrd-3 px-1 pb-0" key={index}>
                                                <img src={prop.icon} height="26px" />
                                                <p className="text-smallest mt-1">{prop.name}</p>
                                            </button>
                                        )
                                    })}
                                </div>
                            )} */}
                                    </div>
                                </div>
                            </div>
                            {this.state.showDropZone && !this.state.showCompressionOption && (
                                <div className="position-absolute w-100 h-100 top-0 left-0" style={{ zIndex: 1 }}  >
                                    <Dropzone
                                        // disabled={this.props.disabled}
                                        ref={el => this.dropzoneRef = el}
                                        multiple={true}
                                        // accept='image/jpeg'
                                        onDrop={(e) => this.onDrop(e, false)}
                                        style={{ flex: 1, cursor: 'pointer', outline: 'none' }}
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <div className=" w-100 h-100 outline-none flexcc p-3" {...getRootProps()} onDragLeave={this.hideDropZone} style={{ backgroundColor: '#fff' }}>
                                                <input {...getInputProps()} />
                                                <div className="w-100 h-100 flexcc flex-column" style={{ border: '3px dashed #eee', borderRadius: 8, pointerEvents: 'none' }}>
                                                    <img className="" src={'/assets/icons/useful/clip.svg'} height={40} draggable={false} />
                                                    <p className="text-semibold text-semibig mt-3">{translate("messenger.Drop Files Here")}</p>
                                                    <p className="text-small mt-1 opacity-5">{translate("messenger.To Send them in this chat")}</p>
                                                </div>
                                            </div>
                                        )}
                                    </Dropzone>
                                </div>
                            )}
                            {this.state.showDropZone && this.state.showCompressionOption && (
                                <div className="d-flex flex-column position-absolute w-100 h-100 top-0 left-0" style={{ zIndex: 1, backgroundColor: '#fff' }} onDragLeave={this.hideDropZone}  >
                                    <Dropzone
                                        // disabled={this.props.disabled}
                                        ref={el => this.dropzoneRef = el}
                                        multiple={true}
                                        // accept='image/jpeg'
                                        onDragOver={(e) => this.showDropZone(e, '1')}
                                        // onDragLeave={this.hideDropZone}
                                        onDrop={(e) => this.onDrop(e, true)}
                                        style={{ flex: 1, cursor: 'pointer', outline: 'none', }}
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <div className=" w-100 flex-1 outline-none flexcc px-3 pt-3 pb-2" {...getRootProps()} style={{ backgroundColor: '#fff' }}>
                                                <input {...getInputProps()} />
                                                <div className="w-100 h-100 flexcc flex-column" style={{ border: '3px dashed #eee', borderRadius: 8, pointerEvents: 'none' }}>
                                                    <img className="" src={'/assets/icons/useful/clip.svg'} height={40} draggable={false} />
                                                    <p className="text-semibold text-semibig mt-3">{translate("messenger.Send With Compression")}</p>
                                                    <p className="text-small mt-1 opacity-5">{translate("messenger.Drop Files Here")}</p>
                                                </div>
                                            </div>
                                        )}
                                    </Dropzone>
                                    <Dropzone
                                        // disabled={this.props.disabled}
                                        ref={el => this.dropzoneRef = el}
                                        multiple={true}
                                        // onDragLeave={this.hideDropZone}
                                        // accept='image/jpeg'
                                        onDrop={(e) => this.onDrop(e, false)}
                                        onDragOver={(e) => this.showDropZone(e, '2')}
                                        style={{ flex: 1, cursor: 'pointer', outline: 'none' }}
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <div className=" w-100 flex-1 outline-none flexcc px-3 pb-3 pt-2" {...getRootProps()} style={{ backgroundColor: '#fff' }}>
                                                <input {...getInputProps()} />
                                                <div className="w-100 h-100 flexcc flex-column" style={{ border: '3px dashed #eee', borderRadius: 8, pointerEvents: 'none' }}>
                                                    <img className="" src={'/assets/icons/useful/clip.svg'} height={40} draggable={false} />
                                                    <p className="text-semibold text-semibig mt-3">{translate("messenger.Send Original")}</p>
                                                    <p className="text-small mt-1 opacity-5">{translate("messenger.Drop Files Here")}</p>
                                                </div>
                                            </div>
                                        )}
                                    </Dropzone>
                                </div>
                            )}
                            <MessengerDropModal ref={el => this.MessengerDropModal = el} height={this.props.height} sendFileMessage={this.sendFileMessage} />
                            <Modal className="" ref={el => this.deletemessage = el} maxWidth={320} style={{}}>
                                <div className='flexc p-4 br-8 flex-column' style={{ backgroundColor: "#fff" }}>
                                    <p className='font-size-16 main-c2 weight-500' style={{}}>{translate('messenger.Delete Message?')}</p>
                                    <p className='font-size-12 main-c7 mt-2' style={{}}>{translate("messenger.Are you sure you want to delete the message?")}</p>
                                    <div className="flexc w-100 pt-4" style={{ justifyContent: 'flex-end' }}>
                                        <div className="flexc mrd-2">
                                            <ButtonAnimated
                                                iconwidth='24px'
                                                onClick={() => { this.hideModal() }}
                                                title={translate('messenger.Cancel')}
                                                textColor={'#a3a2b0'}
                                                bg={'#eee'}
                                            />
                                        </div>
                                        <div className="flexc mx-2">
                                            <ButtonAnimated
                                                iconwidth='24px'
                                                onClick={() => this.deleteMessageAction('me')}
                                                title={translate('messenger.Delete for me')}
                                                icon='/assets/icons/angle-right-white2.svg'
                                                textColor={'#fff'}
                                                bg={`linear-gradient(90deg, #ef0b0bdd, #ef0b0bdd)`}
                                            />
                                        </div>
                                        <div className="flexc mld-2">
                                            <ButtonAnimated
                                                iconwidth='24px'
                                                onClick={() => this.deleteMessageAction('all')}
                                                title={translate('messenger.Delete for all')}
                                                icon='/assets/icons/angle-right-white2.svg'
                                                textColor={'#fff'}
                                                bg={`linear-gradient(90deg, #ef0b0bdd, #ef0b0bdd)`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='mt-4 flexc w-100'>
                                        <button className='px-3 py-2 br-5 mrd-3 cancel-btn2 w-100' onClick={() => this.deleteMessageAction('me')}>
                                            <p className='font-size-14 white'>{translate('messenger.Delete For Me')}</p>
                                        </button>
                                        <button className='px-3 py-2 br-5 mld-3 cancel-btn2 w-100' onClick={() => this.deleteMessageAction('all')}>
                                            <p className='font-size-14 white'>{translate('messenger.Delete For All')}</p>
                                        </button>
                                    </div>
                                    <button className='px-3 py-2 br-5 mx-2 mt-3 w-100' style={{ backgroundColor: "#eee", width: "255px" }} onClick={() => this.hideModal()}>
                                        <p className='font-size-14 main-c5'>{translate('messenger.Cancel')}</p>
                                    </button>
                                </div> */}
                            </Modal>



                            <Modal ref={el => this.ShowImage = el}>
                                <div className=" flexcc">
                                    <div className="position-relative" style={{}}>
                                        <img className='br-10' style={{ objectFit: 'contain', maxHeight: '400px' }} src={this.state?.imageAddress} alt="" />
                                        <a href={this.state?.imageAddress} target={"_blank"} rel="noreferrer" >
                                            <button className='dark-blur-bg2 p-2 br-5 position-absolute' style={{ bottom: '15px', left: '10px' }}>
                                                <img className='flexcc' src='/assets/icons/messenger/arrow.down.to.line.alt.svg' alt="" />
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </Modal>



                            <SidebarView isDesktop={this.props.isDesktop} onClosed={this.onClosed} hight={"100%"} width={this.props.width} ref={el => this.TopicsView = el} hideOverlay={false} widthCondition={{ xs: "40%", sm: "40%", md: '35%', lg: "35%", xl: "25%" }} left={50}>
                                <div className='w-100 h-100 scroll-no-scrollbar'>
                                    <Topics language={this.props.settings.language} closeTopic={this.closeTopic} width={this.props.width} topics={this.props.messenger?.topics} myId={this.props.myId} setMessenger={this.props.setMessenger} messenger={this.props.messenger} messengerInfo={this.state.messengerInfo} colors={this.props.colors} setTopic={this.setTopic} actions={this.props.actions} />
                                </div>
                            </SidebarView>


                        </>
                        {/* )} */}
                    </>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessengerView);